'use client';

import { classNames } from "../../../utils/styles/classNames.js";
import { full, container } from "../Button.css.js";
import { getCssVariant } from "./getCssVariant.js";
function getAnchorContainerClassNames(p) {
  return classNames(
    p.className,
    container,
    p.fullWidth && full,
    getCssVariant(p)[p.onDark ? "onDark" : "onLight"]
  );
}
export {
  getAnchorContainerClassNames
};
